import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IfFeatureEnabledDirective } from './directives/if-feature-enabled.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    IfFeatureEnabledDirective
  ],
  exports: [
    IfFeatureEnabledDirective
  ]
})
export class IfFeatureEnabledModule {}
